const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_auth/sign-up/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { redirectIfLoggedIn } from '@apps/main/lib/route-guards';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/sign-up')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: ({
    location
  }) => redirectIfLoggedIn(location)
});